import React from "react";
import parse from "html-react-parser";
import { Modal } from "react-bootstrap";

const HtmlPreview = ({
    isModalVisible,
    template,
    onHide,
    background = "black",
}) => {
    return (
        <Modal
            show={isModalVisible}
            bsSize="large"
            onHide={() => onHide(false)}
        >
            <Modal.Body>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "16px",
                        background: background,
                    }}
                >
                    <div style={{ width: "100%" }}>
                        {template && parse(template)}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default HtmlPreview;
